import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { EyeIcon, ScanEyeIcon, CircleDotIcon, DropletIcon, BabyIcon, SparklesIcon } from 'lucide-react';
const services = [{
  id: 'eye-exams',
  title: 'Eye Exams',
  description: 'Comprehensive vision testing and eye health evaluations for all ages.',
  icon: EyeIcon
}, {
  id: 'retinal-screening',
  title: 'Retinal Screening',
  description: 'Advanced imaging to detect early signs of eye diseases like glaucoma and macular degeneration.',
  icon: ScanEyeIcon
}, {
  id: 'contact-lenses',
  title: 'Contact Lenses',
  description: 'Expert fittings for all types of contacts, including astigmatism and multifocal lenses.',
  icon: CircleDotIcon
}, {
  id: 'dry-eye-therapy',
  title: 'Dry Eye Therapy',
  description: 'Personalized treatment plans to relieve discomfort and restore tear film balance.',
  icon: DropletIcon
}, {
  id: 'pediatric-eye-care',
  title: 'Pediatric Eye Care',
  description: "Gentle, specialized vision care to ensure your child's eyes develop properly.",
  icon: BabyIcon
}, {
  id: 'lasik-consultation',
  title: 'LASIK Consultation',
  description: 'Pre-operative evaluations and post-operative care for laser vision correction.',
  icon: SparklesIcon
}];
export function ServicesSection() {
  return <section id="services" className="py-20 md:py-28 bg-white" data-id="element-497">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-498">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-499">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-section-mobile md:text-section text-brand-dark mb-4" data-id="element-500">
            Better Vision Means A Better You!
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-subtitle text-neutral-text/80" data-id="element-501">
            Comprehensive eye care tailored to your specific needs, using the
            latest technology.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-502">
          {services.map((service, index) => {
          const Icon = service.icon;
          return <motion.div key={service.title} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} data-id="element-503">
                <Link to={`/blog/${service.id}`} className="block h-full bg-white p-8 rounded-card shadow-card hover:shadow-card-hover hover:-translate-y-1 transition-all duration-300 border border-surface-muted group cursor-pointer focus-ring" data-id="element-504">
                  <div className="w-14 h-14 bg-brand-gold-pale rounded-full flex items-center justify-center mb-6 group-hover:bg-brand-gold transition-colors duration-300" data-id="element-505">
                    <Icon className="w-7 h-7 text-brand-gold group-hover:text-white transition-colors duration-300" data-id="element-506" />
                  </div>
                  <h3 className="text-xl font-heading font-semibold mb-3 text-brand-dark group-hover:text-brand-gold transition-colors" data-id="element-507">
                    {service.title}
                  </h3>
                  <p className="text-neutral-text/70 leading-relaxed" data-id="element-508">
                    {service.description}
                  </p>
                  <div className="mt-6 text-sm font-semibold text-brand-dark group-hover:text-brand-gold flex items-center gap-1 transition-colors" data-id="element-509">
                    Read more <span aria-hidden="true" data-id="element-510">&rarr;</span>
                  </div>
                </Link>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}